/**
 * epgAnchor.tsx.
 */
import Anchor from '@shared/types/props/anchor';
import EpgAnchorContainer from '@components/atoms/container/epgAnchorContainer';
import EpgAnchorImage from '@components/atoms/images/epgAnchorImage';

export default function EpgAnchor(props: Anchor) {
  const { asset } = props;
  return (
    <EpgAnchorContainer>
      <EpgAnchorImage src={asset?.channel?.logo ?? ''} />
    </EpgAnchorContainer>
  );
}
